import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'cloudbuild',
});

export const buildRouteRef = createSubRouteRef({
  id: 'cloudbuild/run',
  path: '/:id',
  parent: rootRouteRef,
});
